<template>
  <Card class="form-stepper-card sm:mt-16 box-shadow-none sm:box-shadow-sm sm:p-24">
    <h1 class="text-h2 centered mt-16 mb-16">What are you looking to do today?</h1>
    <p class="text-body centered mb-24">We'll guide you to the best way to get started.</p>
    <form>
      <fieldset>
        <legend class="sr-only">Which of these apply to you?</legend>
        <Card
          v-for="option in selectionOptions"
          :key="option.value"
          :clickable="true"
          class="w-full mb-12 !p-0"
          :selected="selectedOption === option.value"
          @click="selectOption(option.value)"
        >
          <div class="flex flex-row gap-8 items-center">
            <component :is="option.icon" class="mx-16 my-24 shrink-0" :width="48" :height="48" />
            <div class="flex flex-col gap-6">
              <h3>{{ option.label }}</h3>
            </div>
          </div>
        </Card>
      </fieldset>

      <HelperText v-if="errors.selection" :text="errors.selection" :status="HelperStatus.Error" />

      <div class="flex flex-row-reverse mt-24">
        <RouteStepperNextButton :draft-data="draftData" :validate="validate" @errors="errors = $event" />
      </div>
    </form>
  </Card>
</template>

<script lang="ts">
import { PropType } from 'vue';
import Card from '@/components/card/Card.vue';
import HelperText from '@/components/helper_text/HelperText.vue';
import RouteStepperNextButton from '@/components/route_stepper/RouteStepperNextButton.vue';
import { HelperStatus } from '@/helpers/status';
import {
  CORPORATE_ONBOARDING_GUIDED_SELECTION_OPTIONS,
  CorporateOnboardingGuidedDraft,
  CorporateOnboardingGuidedSelectionOption,
} from './types';

interface Errors {
  selection?: string;
}

interface CorporateOnboardingGuidedSelectionData {
  selectedOption: CorporateOnboardingGuidedSelectionOption | null;
  errors: Errors;
}

export default {
  name: 'CorporateOnboardingGuidedSelection',
  components: {
    Card,
    HelperText,
    RouteStepperNextButton,
  },
  props: {
    draft: {
      type: Object as PropType<CorporateOnboardingGuidedDraft>,
      required: true,
    },
  },
  data(): CorporateOnboardingGuidedSelectionData {
    return {
      selectedOption: this.draft.selection || null,
      errors: {},
    };
  },
  computed: {
    selectionOptions() {
      return CORPORATE_ONBOARDING_GUIDED_SELECTION_OPTIONS;
    },
    HelperStatus(): typeof HelperStatus {
      return HelperStatus;
    },
    draftData(): CorporateOnboardingGuidedDraft {
      return {
        selection: this.selectedOption,
      };
    },
  },
  watch: {
    draft: {
      handler(draft: CorporateOnboardingGuidedDraft): void {
        if (draft.selection && draft.selection !== this.selectedOption) {
          this.selectedOption = draft.selection;
        }
      },
    },
  },
  methods: {
    selectOption(selection: CorporateOnboardingGuidedSelectionOption): void {
      this.selectedOption = selection;
      this.errors = {};
    },
    validate(): Errors {
      const errors: Errors = {};

      if (!this.selectedOption) {
        errors.selection = 'Please select an option.';
      }

      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-stepper-card {
  @media (max-width: 480px) {
    background-color: #fbfbfb !important;
  }
}
</style>
